// ============================================================================
// ProfilesStore - Search User Profiles
// ============================================================================
// Events: 'profiles:error'
// ============================================================================

import { supabase } from 'app/auth/auth.js';
import { EventEmitter } from './event-emitter.js';

const PROFILE_SELECT = 'user_id, full_name, short_name';

class ProfilesStore extends EventEmitter {
    /** Search profiles by name (returns max 20 results) */
    async searchProfiles(query = '') {
        try {
            let request = supabase.from('profiles').select(PROFILE_SELECT);

            if (query?.length >= 1) {
                request = request.or(`full_name.ilike.%${query}%,short_name.ilike.%${query}%`);
            }

            const { data, error } = await request.limit(20);
            if (error) throw error;
            return data || [];
        } catch (error) {
            this.emit('profiles:error', error);
            return [];
        }
    }
}

export { ProfilesStore };
